module.exports = __webpack_public_path__ + "img/mic-clinic-appoint.3ea9d2a9.svg";